import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { APIS } from "../../../utils/APIS";
import { GET, POST, PUT, DELETE } from "../../../utils/Methods";
import { IDS } from "../../../utils/IDS";

// City - Get Total (Read)
export const GetTotalRecordingList = createAsyncThunk(
  "recording_list/get-total",
  async (filter, { rejectWithValue }) => {
    try {
      const res = await GET(
        `${APIS.AllRecordingInfo}?name=${filter?.name ||
          ""}&email=${filter?.email || ""}&page=${filter?.page ||
          IDS.PAGE}&per_page=${filter?.per_page || IDS.PERPAGE}`,
      );

      return res;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  },
);

export const DeleteTotalRecordingList = createAsyncThunk(
  "recording_list/delete",
  async (ids, { rejectWithValue }) => {
    try {
      const deleteIds = Array.isArray(ids) ? ids : [ids];

      await DELETE(`${APIS.AllRecordingInfo}/${deleteIds.join(",")}`);

      return deleteIds;
    } catch (error) {
      return rejectWithValue(
        error?.response?.data?.message ||
          error?.message ||
          "Failed to delete recording",
      );
    }
  },
);

export const Slice = createSlice({
  name: "total-recording-list",
  initialState: {
    data: [],
    current_page: IDS.PAGE,
    total_pages: IDS.TOTALPAGES,
    per_page: IDS.PERPAGE,
    total: IDS.TOTAL,
    status: IDS.SLICESTATUS.Idle,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(GetTotalRecordingList.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(GetTotalRecordingList.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        state.data = action.payload?.data?.data || [];
        state.current_page = action.payload?.data?.current_page || IDS.PAGE;
        state.total_pages = action.payload?.data?.total_pages || IDS.TOTALPAGES;
        state.per_page = action.payload?.data?.per_page || IDS.PERPAGE;
        state.total = action.payload?.data?.total || IDS.TOTAL;
      })
      .addCase(GetTotalRecordingList.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })

      .addCase(DeleteTotalRecordingList.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
        state.error = null;
      })

      .addCase(DeleteTotalRecordingList.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;

        const deletedIds = action.payload;

        state.data = state.data.filter((item) => !deletedIds.includes(item.id));

        state.total = Math.max(0, Number(state.total || 0) - deletedIds.length);

        state.error = null;
      })

      .addCase(DeleteTotalRecordingList.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload || "Failed to delete recording";
      });
  },
});

export default Slice.reducer;
